import { LambdaSchema } from "./types";

const schema: LambdaSchema = {
  columns: [
    { key: "summarize_job_name", label: "summarize_job_name" },
    { key: "llm_calls", label: "llm_calls" },
    { key: "super_org", label: "super_org" },
    { key: "orders_count", label: "orders_count" }
  ],
};

export default schema;

